"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _address = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/address-1"));

var _address2 = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/address-2"));

var _AddressValidation = require("../../utils/AddressValidation");

require("./AddressValidationMessage.less");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var AddressValidationMessage = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AddressValidationMessage, _Component);

  var _super = _createSuper(AddressValidationMessage);

  function AddressValidationMessage(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AddressValidationMessage);
    _this = _super.call(this, props);
    _this.renderMessage = _this.renderMessage.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderCandidates = _this.renderCandidates.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(AddressValidationMessage, [{
    key: "handleClick",
    value: function handleClick(option, i) {
      this.props.onSelect(option, i);
    }
  }, {
    key: "renderMessage",
    value: function renderMessage() {
      var iconSize = 40;
      var iconStyle = {
        verticalAlign: '-30%'
      };
      var validClass = 'valid';

      var validMessage = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_address.default, {
        size: iconSize,
        style: iconStyle
      }), " ", /*#__PURE__*/_react.default.createElement("span", null, "VALID ADDRESS:"), "This address has been validated. Please continue.");

      if (!this.props.valid) {
        var hasCandidates = this.props.candidates.length > 0;
        validClass = "invalid ".concat(hasCandidates ? '' : 'large-margin-after');
        validMessage = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_address2.default, {
          size: iconSize,
          style: iconStyle
        }), " ", /*#__PURE__*/_react.default.createElement("span", null, "UNABLE TO VALIDATE ADDRESS", hasCandidates ? ':' : ''), hasCandidates ? 'Here are some suggestions' : '');
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "address-validation-message ".concat(validClass)
      }, validMessage);
    }
  }, {
    key: "renderCandidates",
    value: function renderCandidates() {
      var _this2 = this;

      var candidates = this.props.candidates.map(function (option, i) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "address-validation-message-candidate",
          key: i,
          onClick: function onClick() {
            return _this2.handleClick(option, i);
          }
        }, (0, _AddressValidation.flattenAddress)(option));
      });
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "address-validation-message-candidates"
      }, candidates), /*#__PURE__*/_react.default.createElement("div", {
        className: "notes text-muted"
      }, "You may still proceed with the address you entered if you believe it is correct."));
    }
  }, {
    key: "render",
    value: function render() {
      var candidateContainer = null;

      if (!this.props.valid && this.props.candidates.length > 0) {
        candidateContainer = this.renderCandidates();
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "address-validation-message-container"
      }, this.renderMessage(), candidateContainer);
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        valid: _propTypes.default.bool,
        candidates: _propTypes.default.array,
        onSelect: _propTypes.default.func
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        valid: false,
        candidates: [],
        onSelect: function onSelect() {}
      };
    }
  }]);
  return AddressValidationMessage;
}(_react.Component);

exports.default = AddressValidationMessage;